import React, { useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../Styles/globalStyle.css";
import useAxiosOperation from "../../../Hooks/useAxiosOperation.js";
import SpinnerIcon from "../../Commands/SpinnerIcon/SpinnerIcon.js";
import DropDownListNew from "../../DropDownList/DropDownListNew";
import FormSettings from "../../Settings/FormSettings/FormSettings";
import uuid from "react-native-uuid";
import { store } from "../../../store.js";
import SaveCommand from "../../Commands/SaveCommand/SaveCommand";
import AddCommand from "../../Commands/AddCommand/AddCommand";
import CloseCommand from "../../Commands/CloseCommand/CloseCommand";
import useGetCurrentsTools from "../../../Hooks/useGetCurrentsTools.js";
import SimpleDialog from "../../SimpleDialog/SimpleDialog";

export default function List(props) {
  const axiosOperation = useAxiosOperation();
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const getCurrentsTools = useGetCurrentsTools();
  const firstNameId = 2;
  const lastNameId = 3;
  const emailId = 4;
  const headerFirstNameId = 15;
  const headerLastNameId = 19;
  const headerEmailId = 27;
  const formData ={ currentMaxId:24 , metaData :[{
    "metaData": [
      {
        "id": 4,
        "order": 2,
        "currentMaxId": 0,
        "type": "DataGrid",
        "selectedValues": [
          10,
          14,
          19,
          22
        ],
        "properties": {
          "name": {
            "value": "DataGrid4",
            "control": "TextBox"
          },
          "text": {
            "value": "DataGrid",
            "control": "TextBox"
          },
          "sliceStart": {
            "value": 1,
            "control": "TextBox"
          },
          "sliceSize": {
            "value": 10,
            "control": "TextBox"
          },
          "size": {
            "value": 0,
            "control": "TextBox",
            "hide": true
          },
          "actualize": {
            "value": 0,
            "control": "TextBox",
            "hide": true
          },
          "search": {
            "value": true,
            "control": "CheckBox"
          },
          "header": {
            "value": true,
            "control": "CheckBox"
          },
          "filter": {
            "value": true,
            "control": "CheckBox"
          },
          "actions": {
            "value": "",
            "control": "TextBox"
          },
          "add": {
            "value": false,
            "control": "CheckBox"
          },
          "delete": {
            "value": false,
            "control": "CheckBox"
          },
          "data": {
            "value": {
              "list": {},
              "mapping": {},
              "tree": {
                "treeDataType": "Form"
              },
              "input": {}
            },
            "options": [
              "Mapping"
            ],
            "control": "TextBox"
          }
        },
        "metaData": [
          {
            "id": 5,
            "order": 5,
            "currentMaxId": 0,
            "type": "SearchGrid",
            "properties": {
              "name": {
                "value": "SearchGrid5",
                "control": "TextBox"
              },
              "text": {
                "value": "SearchGrid",
                "control": "TextBox"
              }
            },
            "metaData": [],
            "policy": {
              "read": true,
              "edit": true,
              "delete": true
            },
            "styles": {
              "fontSize": {
                "value": "14px"
              },
              "fontFamily": {
                "value": "Arial"
              },
              "color": {
                "value": "#212121"
              },
              "backgroundColor": {
                "value": "#e7e7e7"
              },
              "height": {
                "value": "30px",
                "hide": true
              },
              "width": {
                "value": "100%",
                "hide": true
              },
              "display": {
                "value": "flex",
                "hide": true
              },
              "position": {
                "value": "relative",
                "hide": true
              },
              "boxSizing": {
                "value": "border-box",
                "hide": true
              },
              "overflow": {
                "value": "hidden",
                "hide": true
              },
              "border": {
                "value": "1px solid #cccccc"
              }
            },
            "left": {
              "value": 1
            },
            "top": {
              "value": 1
            },
            "globalId": "18eab818-38c5-45bd-ac9d-416eac538668",
            "parentId": [
              4,
              1
            ],
            "parentGlobalId": [
              "66c0b87d-da55-4e55-9fd0-3390c1960dfc",
              "a4a285f5-8651-4a5a-8243-4428ff27cd27"
            ]
          },
          {
            "id": 6,
            "order": 5,
            "currentMaxId": 0,
            "type": "Header",
            "properties": {
              "name": {
                "value": "Header6",
                "control": "TextBox"
              },
              "text": {
                "value": "Header",
                "control": "TextBox"
              }
            },
            "metaData": [
              {
                "id": 10,
                "order": 2,
                "type": "DateTime",
                "properties": {
                  "name": {
                    "value": "DateTime10",
                    "control": "TextBox"
                  },
                  "field": {
                    "value": "DateTime",
                    "control": "TextBox"
                  },
                  "actions": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "type": {
                    "value": "DateTime",
                    "control": "ListBox",
                    "hide": true
                  },
                  "nullable": {
                    "value": true,
                    "control": "CheckBox"
                  },
                  "text": {
                    "value": "Date",
                    "control": "TextBox"
                  },
                  "index": {
                    "value": false,
                    "control": "CheckBox"
                  },
                  "date": {
                    "value": true,
                    "control": "CheckBox"
                  },
                  "dateFormat": {
                    "value": "dd/mm/yyyy",
                    "values": [
                      {
                        "id": "1",
                        "item": "dd/mm/yyyy",
                        "value": "dd/mm/yyyy"
                      },
                      {
                        "id": "2",
                        "item": "mm/dd/yyyy",
                        "value": "mm/dd/yyyy"
                      },
                      {
                        "id": "3",
                        "item": "yyyy/mm/dd",
                        "value": "yyyy/mm/dd"
                      },
                      {
                        "id": "4",
                        "item": "yyyy/dd/mm",
                        "value": "yyyy/dd/mm"
                      }
                    ],
                    "type": "Date",
                    "control": "ListBox"
                  },
                  "time": {
                    "value": false,
                    "control": "CheckBox"
                  },
                  "timeFormat": {
                    "value": "hh:mm:ss",
                    "values": [
                      {
                        "id": "1",
                        "item": "hh:mm:ss",
                        "value": "hh:mm:ss"
                      },
                      {
                        "id": "2",
                        "item": "hh:mm",
                        "value": "hh:mm"
                      },
                      {
                        "id": "3",
                        "item": "hh",
                        "value": "hh"
                      },
                      {
                        "id": "4",
                        "item": "mm",
                        "value": "mm"
                      },
                      {
                        "id": "5",
                        "item": "ss",
                        "value": "ss"
                      }
                    ],
                    "type": "Time",
                    "control": "ListBox"
                  },
                  "operators": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "equal",
                        "value": {
                          "id": "1",
                          "type": "equal"
                        }
                      },
                      {
                        "id": "2",
                        "item": "not equal",
                        "value": {
                          "id": "2",
                          "type": "not equal"
                        }
                      },
                      {
                        "id": "3",
                        "item": "greater",
                        "value": {
                          "id": "3",
                          "type": "greater"
                        }
                      },
                      {
                        "id": "4",
                        "item": "greater & equal",
                        "value": {
                          "id": "4",
                          "type": "greater & equal"
                        }
                      },
                      {
                        "id": "5",
                        "item": "lower",
                        "value": {
                          "id": "5",
                          "type": "lower"
                        }
                      },
                      {
                        "id": "6",
                        "item": "lower & equal",
                        "value": {
                          "id": "6",
                          "type": "lower & equal"
                        }
                      }
                    ]
                  },
                  "validations": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "REQUIRE",
                        "value": {
                          "id": "1",
                          "type": "REQUIRE",
                          "events": [
                            "onBlur",
                            "onSubmit"
                          ]
                        }
                      },
                      {
                        "id": "4",
                        "item": "UNIQUE",
                        "value": {
                          "id": "4",
                          "type": "UNIQUE",
                          "events": [
                            "onBlur"
                          ]
                        }
                      }
                    ]
                  }
                },
                "policy": {
                  "read": true,
                  "edit": true,
                  "delete": true
                },
                "styles": {
                  "fontSize": {
                    "value": "14px"
                  },
                  "fontFamily": {
                    "value": "Arial"
                  },
                  "color": {
                    "value": "#212121"
                  },
                  "height": {
                    "value": "25px"
                  },
                  "width": {
                    "value": "105px",
                    "hide": true
                  },
                  "display": {
                    "value": "flex",
                    "hide": true
                  },
                  "alignItems": {
                    "value": "center",
                    "hide": true
                  },
                  "left": {
                    "value": 10,
                    "hide": true
                  },
                  "top": {
                    "value": 50,
                    "hide": true
                  },
                  "boxSizing": {
                    "value": "border-box",
                    "hide": true
                  },
                  "resize": {
                    "value": "both",
                    "hide": true
                  },
                  "overflow": {
                    "value": "auto",
                    "hide": true
                  }
                },
                "globalId": "77c9e153-efab-49bc-962f-3c0322934742",
                "parentId": [
                  6,
                  4,
                  1
                ],
                "parentGlobalId": [
                  "490c0883-ce25-409e-b397-0cc77c5a4232",
                  "66c0b87d-da55-4e55-9fd0-3390c1960dfc",
                  "a4a285f5-8651-4a5a-8243-4428ff27cd27"
                ]
              },
              {
                "id": 14,
                "order": 2,
                "type": "TextBox",
                "properties": {
                  "name": {
                    "value": "TextBox14",
                    "control": "TextBox"
                  },
                  "field": {
                    "value": "TextBox",
                    "control": "TextBox"
                  },
                  "text": {
                    "value": "Step",
                    "control": "TextBox"
                  },
                  "actions": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "readOnly": {
                    "value": false,
                    "control": "CheckBox"
                  },
                  "placeholder": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "toolTip": {
                    "value": false,
                    "control": "CheckBox"
                  },
                  "toolTipText": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "maxLength": {
                    "value": 200,
                    "control": "TextBox"
                  },
                  "type": {
                    "value": "String",
                    "control": "ListBox",
                    "values": [
                      {
                        "id": "0",
                        "item": "String",
                        "value": "String"
                      },
                      {
                        "id": "1",
                        "item": "Integer",
                        "value": "Integer"
                      },
                      {
                        "id": "2",
                        "item": "Decimal",
                        "value": "Decimal"
                      }
                    ]
                  },
                  "masks": {
                    "value": "",
                    "control": "TextBox",
                    "maskValue": ""
                  },
                  "validations": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "REQUIRE",
                        "value": {
                          "id": "1",
                          "type": "REQUIRE",
                          "events": [
                            "onBlur",
                            "onSubmit"
                          ]
                        }
                      },
                      {
                        "id": "2",
                        "item": "NUMBER",
                        "value": {
                          "id": "2",
                          "type": "NUMBER",
                          "events": [
                            "onChange",
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "3",
                        "item": "EMAIL",
                        "value": {
                          "id": "3",
                          "type": "EMAIL",
                          "events": [
                            "onBlur"
                          ]
                        }
                      },
                      {
                        "id": "4",
                        "item": "UNIQUE",
                        "value": {
                          "id": "4",
                          "type": "UNIQUE",
                          "events": [
                            "onBlur"
                          ]
                        }
                      },
                      {
                        "id": "5",
                        "item": "NOSPACE",
                        "value": {
                          "id": "5",
                          "type": "NOSPACE",
                          "events": [
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "6",
                        "item": "NOSPECIALCHAR",
                        "value": {
                          "id": "6",
                          "type": "NOSPECIALCHAR",
                          "events": [
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "7",
                        "item": "PATTERN",
                        "value": {
                          "id": "7",
                          "type": "PATTERN",
                          "events": [
                            "onBlur"
                          ]
                        }
                      }
                    ]
                  },
                  "operators": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "equal",
                        "value": {
                          "id": "1",
                          "type": "equal"
                        }
                      },
                      {
                        "id": "2",
                        "item": "not equal",
                        "value": {
                          "id": "2",
                          "type": "not equal"
                        }
                      },
                      {
                        "id": "3",
                        "item": "greater",
                        "value": {
                          "id": "3",
                          "type": "greater"
                        }
                      },
                      {
                        "id": "4",
                        "item": "greater & equal",
                        "value": {
                          "id": "4",
                          "type": "greater & equal"
                        }
                      },
                      {
                        "id": "5",
                        "item": "lower",
                        "value": {
                          "id": "5",
                          "type": "lower"
                        }
                      },
                      {
                        "id": "6",
                        "item": "lower & equal",
                        "value": {
                          "id": "6",
                          "type": "lower & equal"
                        }
                      },
                      {
                        "id": "7",
                        "item": "contains",
                        "value": {
                          "id": "7",
                          "type": "contains"
                        }
                      },
                      {
                        "id": "8",
                        "item": "starts with",
                        "value": {
                          "id": "8",
                          "type": "starts with"
                        }
                      },
                      {
                        "id": "9",
                        "item": "ends with",
                        "value": {
                          "id": "9",
                          "type": "ends with"
                        }
                      }
                    ]
                  },
                  "prefix": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "suffix": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "wholeNumberLength": {
                    "value": 10,
                    "control": "TextBox"
                  },
                  "decimalSize": {
                    "value": 2,
                    "control": "TextBox"
                  },
                  "decimalSeparator": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "groupSize": {
                    "value": 3,
                    "control": "TextBox"
                  },
                  "groupSeparator": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "index": {
                    "value": false,
                    "control": "CheckBox"
                  }
                },
                "policy": {
                  "read": true,
                  "edit": true,
                  "delete": true
                },
                "styles": {
                  "fontSize": {
                    "value": "14px"
                  },
                  "fontFamily": {
                    "value": "Arial"
                  },
                  "color": {
                    "value": "#212121"
                  },
                  "left": {
                    "value": 10,
                    "hide": true
                  },
                  "top": {
                    "value": 50,
                    "hide": true
                  },
                  "width": {
                    "value": "209px",
                    "hide": true
                  },
                  "display": {
                    "value": "flex",
                    "hide": true
                  },
                  "height": {
                    "value": "25px",
                    "hide": true
                  },
                  "visibility": {
                    "value": "visible"
                  },
                  "borderLeft": {
                    "value": "1px solid #cccccc"
                  },
                  "borderTop": {
                    "value": "1px solid #cccccc"
                  },
                  "borderTopLeftRadius": {
                    "value": "2px"
                  },
                  "borderTopRightRadius": {
                    "value": "2px"
                  },
                  "borderRight": {
                    "value": "1px solid #cccccc"
                  },
                  "borderBottom": {
                    "value": "1px solid #cccccc"
                  },
                  "borderBottomLeftRadius": {
                    "value": "2px"
                  },
                  "borderBottomRightRadius": {
                    "value": "2px"
                  },
                  "background": {
                    "value": "white"
                  },
                  "boxSizing": {
                    "value": "border-box",
                    "hide": true
                  },
                  "textAlign": {
                    "value": "left"
                  },
                  "resize": {
                    "value": "both",
                    "hide": true
                  },
                  "overflow": {
                    "value": "auto",
                    "hide": true
                  }
                },
                "globalId": "99844deb-2c21-4d1f-a683-34d8e04ce1e9",
                "parentId": [
                  6,
                  4,
                  1
                ],
                "parentGlobalId": [
                  "490c0883-ce25-409e-b397-0cc77c5a4232",
                  "66c0b87d-da55-4e55-9fd0-3390c1960dfc",
                  "a4a285f5-8651-4a5a-8243-4428ff27cd27"
                ]
              },
              {
                "id": 22,
                "order": 2,
                "type": "TextBox",
                "properties": {
                  "name": {
                    "value": "TextBox25",
                    "control": "TextBox"
                  },
                  "field": {
                    "value": "TextBox",
                    "control": "TextBox"
                  },
                  "text": {
                    "value": "Decision",
                    "control": "TextBox"
                  },
                  "actions": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "readOnly": {
                    "value": false,
                    "control": "CheckBox"
                  },
                  "placeholder": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "toolTip": {
                    "value": false,
                    "control": "CheckBox"
                  },
                  "toolTipText": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "maxLength": {
                    "value": 200,
                    "control": "TextBox"
                  },
                  "type": {
                    "value": "String",
                    "control": "ListBox",
                    "values": [
                      {
                        "id": "0",
                        "item": "String",
                        "value": "String"
                      },
                      {
                        "id": "1",
                        "item": "Integer",
                        "value": "Integer"
                      },
                      {
                        "id": "2",
                        "item": "Decimal",
                        "value": "Decimal"
                      }
                    ]
                  },
                  "masks": {
                    "value": "",
                    "control": "TextBox",
                    "maskValue": ""
                  },
                  "validations": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "REQUIRE",
                        "value": {
                          "id": "1",
                          "type": "REQUIRE",
                          "events": [
                            "onBlur",
                            "onSubmit"
                          ]
                        }
                      },
                      {
                        "id": "2",
                        "item": "NUMBER",
                        "value": {
                          "id": "2",
                          "type": "NUMBER",
                          "events": [
                            "onChange",
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "3",
                        "item": "EMAIL",
                        "value": {
                          "id": "3",
                          "type": "EMAIL",
                          "events": [
                            "onBlur"
                          ]
                        }
                      },
                      {
                        "id": "4",
                        "item": "UNIQUE",
                        "value": {
                          "id": "4",
                          "type": "UNIQUE",
                          "events": [
                            "onBlur"
                          ]
                        }
                      },
                      {
                        "id": "5",
                        "item": "NOSPACE",
                        "value": {
                          "id": "5",
                          "type": "NOSPACE",
                          "events": [
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "6",
                        "item": "NOSPECIALCHAR",
                        "value": {
                          "id": "6",
                          "type": "NOSPECIALCHAR",
                          "events": [
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "7",
                        "item": "PATTERN",
                        "value": {
                          "id": "7",
                          "type": "PATTERN",
                          "events": [
                            "onBlur"
                          ]
                        }
                      }
                    ]
                  },
                  "operators": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "equal",
                        "value": {
                          "id": "1",
                          "type": "equal"
                        }
                      },
                      {
                        "id": "2",
                        "item": "not equal",
                        "value": {
                          "id": "2",
                          "type": "not equal"
                        }
                      },
                      {
                        "id": "3",
                        "item": "greater",
                        "value": {
                          "id": "3",
                          "type": "greater"
                        }
                      },
                      {
                        "id": "4",
                        "item": "greater & equal",
                        "value": {
                          "id": "4",
                          "type": "greater & equal"
                        }
                      },
                      {
                        "id": "5",
                        "item": "lower",
                        "value": {
                          "id": "5",
                          "type": "lower"
                        }
                      },
                      {
                        "id": "6",
                        "item": "lower & equal",
                        "value": {
                          "id": "6",
                          "type": "lower & equal"
                        }
                      },
                      {
                        "id": "7",
                        "item": "contains",
                        "value": {
                          "id": "7",
                          "type": "contains"
                        }
                      },
                      {
                        "id": "8",
                        "item": "starts with",
                        "value": {
                          "id": "8",
                          "type": "starts with"
                        }
                      },
                      {
                        "id": "9",
                        "item": "ends with",
                        "value": {
                          "id": "9",
                          "type": "ends with"
                        }
                      }
                    ]
                  },
                  "prefix": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "suffix": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "wholeNumberLength": {
                    "value": 10,
                    "control": "TextBox"
                  },
                  "decimalSize": {
                    "value": 2,
                    "control": "TextBox"
                  },
                  "decimalSeparator": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "groupSize": {
                    "value": 3,
                    "control": "TextBox"
                  },
                  "groupSeparator": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "index": {
                    "value": false,
                    "control": "CheckBox"
                  }
                },
                "policy": {
                  "read": true,
                  "edit": true,
                  "delete": true
                },
                "styles": {
                  "fontSize": {
                    "value": "14px"
                  },
                  "fontFamily": {
                    "value": "Arial"
                  },
                  "color": {
                    "value": "#212121"
                  },
                  "left": {
                    "value": 708,
                    "hide": true
                  },
                  "top": {
                    "value": 38,
                    "hide": true
                  },
                  "width": {
                    "value": "176px",
                    "hide": true
                  },
                  "display": {
                    "value": "flex",
                    "hide": true
                  },
                  "height": {
                    "value": "25px",
                    "hide": true
                  },
                  "visibility": {
                    "value": "visible"
                  },
                  "borderLeft": {
                    "value": "1px solid #cccccc"
                  },
                  "borderTop": {
                    "value": "1px solid #cccccc"
                  },
                  "borderTopLeftRadius": {
                    "value": "2px"
                  },
                  "borderTopRightRadius": {
                    "value": "2px"
                  },
                  "borderRight": {
                    "value": "1px solid #cccccc"
                  },
                  "borderBottom": {
                    "value": "1px solid #cccccc"
                  },
                  "borderBottomLeftRadius": {
                    "value": "2px"
                  },
                  "borderBottomRightRadius": {
                    "value": "2px"
                  },
                  "background": {
                    "value": "white"
                  },
                  "boxSizing": {
                    "value": "border-box",
                    "hide": true
                  },
                  "textAlign": {
                    "value": "left"
                  },
                  "resize": {
                    "value": "both"
                  },
                  "overflow": {
                    "value": "auto",
                    "hide": true
                  }
                },
                "globalId": "90d01539-897a-465d-a39d-8b7c13890d61",
                "parentId": [
                  6,
                  4,
                  1
                ],
                "parentGlobalId": [
                  "490c0883-ce25-409e-b397-0cc77c5a4232",
                  "66c0b87d-da55-4e55-9fd0-3390c1960dfc",
                  "a4a285f5-8651-4a5a-8243-4428ff27cd27"
                ],
                "left": {
                  "value": 708
                },
                "top": {
                  "value": 38
                },
                "clickRelativePosition": {
                  "left": 45,
                  "top": 17
                }
              }
            ],
            "policy": {
              "read": true,
              "edit": true,
              "delete": true
            },
            "styles": {
              "fontSize": {
                "value": "14px"
              },
              "fontFamily": {
                "value": "Arial"
              },
              "color": {
                "value": "#cccccc"
              },
              "backgroundColor": {
                "value": "#e7e7e7"
              },
              "height": {
                "value": "30px",
                "hide": true
              },
              "width": {
                "value": "100%",
                "hide": true
              },
              "display": {
                "value": "flex",
                "hide": true
              },
              "position": {
                "value": "relative",
                "hide": true
              },
              "boxSizing": {
                "value": "border-box",
                "hide": true
              },
              "overflow": {
                "value": "hidden",
                "hide": true
              },
              "border": {
                "value": "1px solid #cccccc"
              }
            },
            "left": {
              "value": 1
            },
            "top": {
              "value": 1
            },
            "globalId": "490c0883-ce25-409e-b397-0cc77c5a4232",
            "parentId": [
              4,
              1
            ],
            "parentGlobalId": [
              "66c0b87d-da55-4e55-9fd0-3390c1960dfc",
              "a4a285f5-8651-4a5a-8243-4428ff27cd27"
            ]
          },
          {
            "id": 7,
            "order": 5,
            "currentMaxId": 0,
            "type": "Filter",
            "properties": {
              "name": {
                "value": "Filter7",
                "control": "TextBox"
              },
              "text": {
                "value": "Filter",
                "control": "TextBox"
              }
            },
            "metaData": [
              {
                "id": 12,
                "order": 2,
                "type": "DateTime",
                "properties": {
                  "name": {
                    "value": "DateTime12",
                    "control": "TextBox"
                  },
                  "field": {
                    "value": "DateTime",
                    "control": "TextBox"
                  },
                  "actions": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "type": {
                    "value": "DateTime",
                    "control": "ListBox",
                    "hide": true
                  },
                  "nullable": {
                    "value": true,
                    "control": "CheckBox"
                  },
                  "text": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "index": {
                    "value": false,
                    "control": "CheckBox"
                  },
                  "date": {
                    "value": true,
                    "control": "CheckBox"
                  },
                  "dateFormat": {
                    "value": "dd/mm/yyyy",
                    "values": [
                      {
                        "id": "1",
                        "item": "dd/mm/yyyy",
                        "value": "dd/mm/yyyy"
                      },
                      {
                        "id": "2",
                        "item": "mm/dd/yyyy",
                        "value": "mm/dd/yyyy"
                      },
                      {
                        "id": "3",
                        "item": "yyyy/mm/dd",
                        "value": "yyyy/mm/dd"
                      },
                      {
                        "id": "4",
                        "item": "yyyy/dd/mm",
                        "value": "yyyy/dd/mm"
                      }
                    ],
                    "type": "Date",
                    "control": "ListBox"
                  },
                  "time": {
                    "value": false,
                    "control": "CheckBox"
                  },
                  "timeFormat": {
                    "value": "hh:mm:ss",
                    "values": [
                      {
                        "id": "1",
                        "item": "hh:mm:ss",
                        "value": "hh:mm:ss"
                      },
                      {
                        "id": "2",
                        "item": "hh:mm",
                        "value": "hh:mm"
                      },
                      {
                        "id": "3",
                        "item": "hh",
                        "value": "hh"
                      },
                      {
                        "id": "4",
                        "item": "mm",
                        "value": "mm"
                      },
                      {
                        "id": "5",
                        "item": "ss",
                        "value": "ss"
                      }
                    ],
                    "type": "Time",
                    "control": "ListBox"
                  },
                  "operators": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "equal",
                        "value": {
                          "id": "1",
                          "type": "equal"
                        }
                      },
                      {
                        "id": "2",
                        "item": "not equal",
                        "value": {
                          "id": "2",
                          "type": "not equal"
                        }
                      },
                      {
                        "id": "3",
                        "item": "greater",
                        "value": {
                          "id": "3",
                          "type": "greater"
                        }
                      },
                      {
                        "id": "4",
                        "item": "greater & equal",
                        "value": {
                          "id": "4",
                          "type": "greater & equal"
                        }
                      },
                      {
                        "id": "5",
                        "item": "lower",
                        "value": {
                          "id": "5",
                          "type": "lower"
                        }
                      },
                      {
                        "id": "6",
                        "item": "lower & equal",
                        "value": {
                          "id": "6",
                          "type": "lower & equal"
                        }
                      }
                    ]
                  },
                  "validations": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "REQUIRE",
                        "value": {
                          "id": "1",
                          "type": "REQUIRE",
                          "events": [
                            "onBlur",
                            "onSubmit"
                          ]
                        }
                      },
                      {
                        "id": "4",
                        "item": "UNIQUE",
                        "value": {
                          "id": "4",
                          "type": "UNIQUE",
                          "events": [
                            "onBlur"
                          ]
                        }
                      }
                    ]
                  }
                },
                "policy": {
                  "read": true,
                  "edit": true,
                  "delete": true
                },
                "styles": {
                  "fontSize": {
                    "value": "14px"
                  },
                  "fontFamily": {
                    "value": "Arial"
                  },
                  "color": {
                    "value": "#212121"
                  },
                  "height": {
                    "value": "25px"
                  },
                  "width": {
                    "value": "105px",
                    "hide": true
                  },
                  "display": {
                    "value": "flex",
                    "hide": true
                  },
                  "alignItems": {
                    "value": "center",
                    "hide": true
                  },
                  "left": {
                    "value": 10,
                    "hide": true
                  },
                  "top": {
                    "value": 50,
                    "hide": true
                  },
                  "boxSizing": {
                    "value": "border-box",
                    "hide": true
                  },
                  "resize": {
                    "value": "both",
                    "hide": true
                  },
                  "overflow": {
                    "value": "auto",
                    "hide": true
                  }
                },
                "globalId": "2ec1ffb2-0cee-495c-b881-86101621a82b",
                "parentId": [
                  7,
                  4,
                  1
                ],
                "parentGlobalId": [
                  "39d5f8a7-96df-453b-8533-25aec38f5283",
                  "66c0b87d-da55-4e55-9fd0-3390c1960dfc",
                  "a4a285f5-8651-4a5a-8243-4428ff27cd27"
                ],
                "headerId": 10
              },
              {
                "id": 16,
                "order": 2,
                "type": "TextBox",
                "properties": {
                  "name": {
                    "value": "TextBox16",
                    "control": "TextBox"
                  },
                  "field": {
                    "value": "TextBox",
                    "control": "TextBox"
                  },
                  "text": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "actions": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "readOnly": {
                    "value": false,
                    "control": "CheckBox"
                  },
                  "placeholder": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "toolTip": {
                    "value": true,
                    "control": "CheckBox"
                  },
                  "toolTipText": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "maxLength": {
                    "value": 200,
                    "control": "TextBox"
                  },
                  "type": {
                    "value": "String",
                    "control": "ListBox",
                    "values": [
                      {
                        "id": "0",
                        "item": "String",
                        "value": "String"
                      },
                      {
                        "id": "1",
                        "item": "Integer",
                        "value": "Integer"
                      },
                      {
                        "id": "2",
                        "item": "Decimal",
                        "value": "Decimal"
                      }
                    ]
                  },
                  "masks": {
                    "value": "",
                    "control": "TextBox",
                    "maskValue": ""
                  },
                  "validations": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "REQUIRE",
                        "value": {
                          "id": "1",
                          "type": "REQUIRE",
                          "events": [
                            "onBlur",
                            "onSubmit"
                          ]
                        }
                      },
                      {
                        "id": "2",
                        "item": "NUMBER",
                        "value": {
                          "id": "2",
                          "type": "NUMBER",
                          "events": [
                            "onChange",
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "3",
                        "item": "EMAIL",
                        "value": {
                          "id": "3",
                          "type": "EMAIL",
                          "events": [
                            "onBlur"
                          ]
                        }
                      },
                      {
                        "id": "4",
                        "item": "UNIQUE",
                        "value": {
                          "id": "4",
                          "type": "UNIQUE",
                          "events": [
                            "onBlur"
                          ]
                        }
                      },
                      {
                        "id": "5",
                        "item": "NOSPACE",
                        "value": {
                          "id": "5",
                          "type": "NOSPACE",
                          "events": [
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "6",
                        "item": "NOSPECIALCHAR",
                        "value": {
                          "id": "6",
                          "type": "NOSPECIALCHAR",
                          "events": [
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "7",
                        "item": "PATTERN",
                        "value": {
                          "id": "7",
                          "type": "PATTERN",
                          "events": [
                            "onBlur"
                          ]
                        }
                      }
                    ]
                  },
                  "operators": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "equal",
                        "value": {
                          "id": "1",
                          "type": "equal"
                        }
                      },
                      {
                        "id": "2",
                        "item": "not equal",
                        "value": {
                          "id": "2",
                          "type": "not equal"
                        }
                      },
                      {
                        "id": "3",
                        "item": "greater",
                        "value": {
                          "id": "3",
                          "type": "greater"
                        }
                      },
                      {
                        "id": "4",
                        "item": "greater & equal",
                        "value": {
                          "id": "4",
                          "type": "greater & equal"
                        }
                      },
                      {
                        "id": "5",
                        "item": "lower",
                        "value": {
                          "id": "5",
                          "type": "lower"
                        }
                      },
                      {
                        "id": "6",
                        "item": "lower & equal",
                        "value": {
                          "id": "6",
                          "type": "lower & equal"
                        }
                      },
                      {
                        "id": "7",
                        "item": "contains",
                        "value": {
                          "id": "7",
                          "type": "contains"
                        }
                      },
                      {
                        "id": "8",
                        "item": "starts with",
                        "value": {
                          "id": "8",
                          "type": "starts with"
                        }
                      },
                      {
                        "id": "9",
                        "item": "ends with",
                        "value": {
                          "id": "9",
                          "type": "ends with"
                        }
                      }
                    ]
                  },
                  "prefix": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "suffix": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "wholeNumberLength": {
                    "value": 10,
                    "control": "TextBox"
                  },
                  "decimalSize": {
                    "value": 2,
                    "control": "TextBox"
                  },
                  "decimalSeparator": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "groupSize": {
                    "value": 3,
                    "control": "TextBox"
                  },
                  "groupSeparator": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "index": {
                    "value": false,
                    "control": "CheckBox"
                  }
                },
                "policy": {
                  "read": true,
                  "edit": true,
                  "delete": true
                },
                "styles": {
                  "fontSize": {
                    "value": "14px"
                  },
                  "fontFamily": {
                    "value": "Arial"
                  },
                  "color": {
                    "value": "#212121"
                  },
                  "left": {
                    "value": 10,
                    "hide": true
                  },
                  "top": {
                    "value": 50,
                    "hide": true
                  },
                  "width": {
                    "value": "209px",
                    "hide": true
                  },
                  "display": {
                    "value": "flex",
                    "hide": true
                  },
                  "height": {
                    "value": "25px",
                    "hide": true
                  },
                  "visibility": {
                    "value": "visible"
                  },
                  "borderLeft": {
                    "value": "1px solid #cccccc"
                  },
                  "borderTop": {
                    "value": "1px solid #cccccc"
                  },
                  "borderTopLeftRadius": {
                    "value": "2px"
                  },
                  "borderTopRightRadius": {
                    "value": "2px"
                  },
                  "borderRight": {
                    "value": "1px solid #cccccc"
                  },
                  "borderBottom": {
                    "value": "1px solid #cccccc"
                  },
                  "borderBottomLeftRadius": {
                    "value": "2px"
                  },
                  "borderBottomRightRadius": {
                    "value": "2px"
                  },
                  "background": {
                    "value": "white"
                  },
                  "boxSizing": {
                    "value": "border-box",
                    "hide": true
                  },
                  "textAlign": {
                    "value": "left"
                  },
                  "resize": {
                    "value": "both",
                    "hide": true
                  },
                  "overflow": {
                    "value": "auto",
                    "hide": true
                  }
                },
                "globalId": "d8f7b1e2-008e-4f36-927c-6984031fca71",
                "parentId": [
                  7,
                  4,
                  1
                ],
                "parentGlobalId": [
                  "39d5f8a7-96df-453b-8533-25aec38f5283",
                  "66c0b87d-da55-4e55-9fd0-3390c1960dfc",
                  "a4a285f5-8651-4a5a-8243-4428ff27cd27"
                ],
                "headerId": 14
              },
              {
                "id": 24,
                "order": 2,
                "type": "TextBox",
                "properties": {
                  "name": {
                    "value": "TextBox24",
                    "control": "TextBox"
                  },
                  "field": {
                    "value": "TextBox",
                    "control": "TextBox"
                  },
                  "text": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "actions": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "readOnly": {
                    "value": false,
                    "control": "CheckBox"
                  },
                  "placeholder": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "toolTip": {
                    "value": true,
                    "control": "CheckBox"
                  },
                  "toolTipText": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "maxLength": {
                    "value": 200,
                    "control": "TextBox"
                  },
                  "type": {
                    "value": "String",
                    "control": "ListBox",
                    "values": [
                      {
                        "id": "0",
                        "item": "String",
                        "value": "String"
                      },
                      {
                        "id": "1",
                        "item": "Integer",
                        "value": "Integer"
                      },
                      {
                        "id": "2",
                        "item": "Decimal",
                        "value": "Decimal"
                      }
                    ]
                  },
                  "masks": {
                    "value": "",
                    "control": "TextBox",
                    "maskValue": ""
                  },
                  "validations": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "REQUIRE",
                        "value": {
                          "id": "1",
                          "type": "REQUIRE",
                          "events": [
                            "onBlur",
                            "onSubmit"
                          ]
                        }
                      },
                      {
                        "id": "2",
                        "item": "NUMBER",
                        "value": {
                          "id": "2",
                          "type": "NUMBER",
                          "events": [
                            "onChange",
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "3",
                        "item": "EMAIL",
                        "value": {
                          "id": "3",
                          "type": "EMAIL",
                          "events": [
                            "onBlur"
                          ]
                        }
                      },
                      {
                        "id": "4",
                        "item": "UNIQUE",
                        "value": {
                          "id": "4",
                          "type": "UNIQUE",
                          "events": [
                            "onBlur"
                          ]
                        }
                      },
                      {
                        "id": "5",
                        "item": "NOSPACE",
                        "value": {
                          "id": "5",
                          "type": "NOSPACE",
                          "events": [
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "6",
                        "item": "NOSPECIALCHAR",
                        "value": {
                          "id": "6",
                          "type": "NOSPECIALCHAR",
                          "events": [
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "7",
                        "item": "PATTERN",
                        "value": {
                          "id": "7",
                          "type": "PATTERN",
                          "events": [
                            "onBlur"
                          ]
                        }
                      }
                    ]
                  },
                  "operators": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "equal",
                        "value": {
                          "id": "1",
                          "type": "equal"
                        }
                      },
                      {
                        "id": "2",
                        "item": "not equal",
                        "value": {
                          "id": "2",
                          "type": "not equal"
                        }
                      },
                      {
                        "id": "3",
                        "item": "greater",
                        "value": {
                          "id": "3",
                          "type": "greater"
                        }
                      },
                      {
                        "id": "4",
                        "item": "greater & equal",
                        "value": {
                          "id": "4",
                          "type": "greater & equal"
                        }
                      },
                      {
                        "id": "5",
                        "item": "lower",
                        "value": {
                          "id": "5",
                          "type": "lower"
                        }
                      },
                      {
                        "id": "6",
                        "item": "lower & equal",
                        "value": {
                          "id": "6",
                          "type": "lower & equal"
                        }
                      },
                      {
                        "id": "7",
                        "item": "contains",
                        "value": {
                          "id": "7",
                          "type": "contains"
                        }
                      },
                      {
                        "id": "8",
                        "item": "starts with",
                        "value": {
                          "id": "8",
                          "type": "starts with"
                        }
                      },
                      {
                        "id": "9",
                        "item": "ends with",
                        "value": {
                          "id": "9",
                          "type": "ends with"
                        }
                      }
                    ]
                  },
                  "prefix": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "suffix": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "wholeNumberLength": {
                    "value": 10,
                    "control": "TextBox"
                  },
                  "decimalSize": {
                    "value": 2,
                    "control": "TextBox"
                  },
                  "decimalSeparator": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "groupSize": {
                    "value": 3,
                    "control": "TextBox"
                  },
                  "groupSeparator": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "index": {
                    "value": false,
                    "control": "CheckBox"
                  }
                },
                "policy": {
                  "read": true,
                  "edit": true,
                  "delete": true
                },
                "styles": {
                  "fontSize": {
                    "value": "14px"
                  },
                  "fontFamily": {
                    "value": "Arial"
                  },
                  "color": {
                    "value": "#212121"
                  },
                  "left": {
                    "value": 708,
                    "hide": true
                  },
                  "top": {
                    "value": 38,
                    "hide": true
                  },
                  "width": {
                    "value": "176px",
                    "hide": true
                  },
                  "display": {
                    "value": "flex",
                    "hide": true
                  },
                  "height": {
                    "value": "25px",
                    "hide": true
                  },
                  "visibility": {
                    "value": "visible"
                  },
                  "borderLeft": {
                    "value": "1px solid #cccccc"
                  },
                  "borderTop": {
                    "value": "1px solid #cccccc"
                  },
                  "borderTopLeftRadius": {
                    "value": "2px"
                  },
                  "borderTopRightRadius": {
                    "value": "2px"
                  },
                  "borderRight": {
                    "value": "1px solid #cccccc"
                  },
                  "borderBottom": {
                    "value": "1px solid #cccccc"
                  },
                  "borderBottomLeftRadius": {
                    "value": "2px"
                  },
                  "borderBottomRightRadius": {
                    "value": "2px"
                  },
                  "background": {
                    "value": "white"
                  },
                  "boxSizing": {
                    "value": "border-box",
                    "hide": true
                  },
                  "textAlign": {
                    "value": "left"
                  },
                  "resize": {
                    "value": "both"
                  },
                  "overflow": {
                    "value": "auto",
                    "hide": true
                  }
                },
                "globalId": "214301d4-c3ac-4b30-8bfd-ea59ad3659cf",
                "parentId": [
                  7,
                  4,
                  1
                ],
                "parentGlobalId": [
                  "39d5f8a7-96df-453b-8533-25aec38f5283",
                  "66c0b87d-da55-4e55-9fd0-3390c1960dfc",
                  "a4a285f5-8651-4a5a-8243-4428ff27cd27"
                ],
                "left": {
                  "value": 708
                },
                "top": {
                  "value": 38
                },
                "clickRelativePosition": {
                  "left": 45,
                  "top": 17
                },
                "headerId": 22
              }
            ],
            "policy": {
              "read": true,
              "edit": true,
              "delete": true
            },
            "styles": {
              "fontSize": {
                "value": "14px"
              },
              "fontFamily": {
                "value": "Arial"
              },
              "color": {
                "value": "#cccccc"
              },
              "backgroundColor": {
                "value": "white"
              },
              "height": {
                "value": "30px",
                "hide": true
              },
              "width": {
                "value": "100%",
                "hide": true
              },
              "display": {
                "value": "flex",
                "hide": true
              },
              "position": {
                "value": "relative",
                "hide": true
              },
              "boxSizing": {
                "value": "border-box",
                "hide": true
              },
              "overflow": {
                "value": "hidden",
                "hide": true
              },
              "border": {
                "value": "1px solid #cccccc"
              }
            },
            "left": {
              "value": 1
            },
            "top": {
              "value": 1
            },
            "globalId": "39d5f8a7-96df-453b-8533-25aec38f5283",
            "parentId": [
              4,
              1
            ],
            "parentGlobalId": [
              "66c0b87d-da55-4e55-9fd0-3390c1960dfc",
              "a4a285f5-8651-4a5a-8243-4428ff27cd27"
            ]
          },
          {
            "id": 8,
            "order": 5,
            "currentMaxId": 0,
            "type": "Rows",
            "properties": {
              "name": {
                "value": "Rows8",
                "control": "TextBox"
              },
              "text": {
                "value": "Rows",
                "control": "TextBox"
              }
            },
            "metaData": [
              {
                "id": 11,
                "order": 2,
                "type": "DateTime",
                "properties": {
                  "name": {
                    "value": "Date",
                    "control": "TextBox"
                  },
                  "field": {
                    "value": "DateTime",
                    "control": "TextBox"
                  },
                  "actions": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "type": {
                    "value": "DateTime",
                    "control": "ListBox",
                    "hide": true
                  },
                  "nullable": {
                    "value": true,
                    "control": "CheckBox"
                  },
                  "text": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "index": {
                    "value": false,
                    "control": "CheckBox"
                  },
                  "date": {
                    "value": true,
                    "control": "CheckBox"
                  },
                  "dateFormat": {
                    "value": "dd/mm/yyyy",
                    "values": [
                      {
                        "id": "1",
                        "item": "dd/mm/yyyy",
                        "value": "dd/mm/yyyy"
                      },
                      {
                        "id": "2",
                        "item": "mm/dd/yyyy",
                        "value": "mm/dd/yyyy"
                      },
                      {
                        "id": "3",
                        "item": "yyyy/mm/dd",
                        "value": "yyyy/mm/dd"
                      },
                      {
                        "id": "4",
                        "item": "yyyy/dd/mm",
                        "value": "yyyy/dd/mm"
                      }
                    ],
                    "type": "Date",
                    "control": "ListBox"
                  },
                  "time": {
                    "value": false,
                    "control": "CheckBox"
                  },
                  "timeFormat": {
                    "value": "hh:mm:ss",
                    "values": [
                      {
                        "id": "1",
                        "item": "hh:mm:ss",
                        "value": "hh:mm:ss"
                      },
                      {
                        "id": "2",
                        "item": "hh:mm",
                        "value": "hh:mm"
                      },
                      {
                        "id": "3",
                        "item": "hh",
                        "value": "hh"
                      },
                      {
                        "id": "4",
                        "item": "mm",
                        "value": "mm"
                      },
                      {
                        "id": "5",
                        "item": "ss",
                        "value": "ss"
                      }
                    ],
                    "type": "Time",
                    "control": "ListBox"
                  },
                  "operators": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "equal",
                        "value": {
                          "id": "1",
                          "type": "equal"
                        }
                      },
                      {
                        "id": "2",
                        "item": "not equal",
                        "value": {
                          "id": "2",
                          "type": "not equal"
                        }
                      },
                      {
                        "id": "3",
                        "item": "greater",
                        "value": {
                          "id": "3",
                          "type": "greater"
                        }
                      },
                      {
                        "id": "4",
                        "item": "greater & equal",
                        "value": {
                          "id": "4",
                          "type": "greater & equal"
                        }
                      },
                      {
                        "id": "5",
                        "item": "lower",
                        "value": {
                          "id": "5",
                          "type": "lower"
                        }
                      },
                      {
                        "id": "6",
                        "item": "lower & equal",
                        "value": {
                          "id": "6",
                          "type": "lower & equal"
                        }
                      }
                    ]
                  },
                  "validations": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "REQUIRE",
                        "value": {
                          "id": "1",
                          "type": "REQUIRE",
                          "events": [
                            "onBlur",
                            "onSubmit"
                          ]
                        }
                      },
                      {
                        "id": "4",
                        "item": "UNIQUE",
                        "value": {
                          "id": "4",
                          "type": "UNIQUE",
                          "events": [
                            "onBlur"
                          ]
                        }
                      }
                    ]
                  }
                },
                "policy": {
                  "read": true,
                  "edit": true,
                  "delete": true
                },
                "styles": {
                  "fontSize": {
                    "value": "14px"
                  },
                  "fontFamily": {
                    "value": "Arial"
                  },
                  "color": {
                    "value": "#212121"
                  },
                  "height": {
                    "value": "25px"
                  },
                  "width": {
                    "value": "105px",
                    "hide": true
                  },
                  "display": {
                    "value": "flex",
                    "hide": true
                  },
                  "alignItems": {
                    "value": "center",
                    "hide": true
                  },
                  "left": {
                    "value": 10,
                    "hide": true
                  },
                  "top": {
                    "value": 50,
                    "hide": true
                  },
                  "boxSizing": {
                    "value": "border-box",
                    "hide": true
                  },
                  "resize": {
                    "value": "both",
                    "hide": true
                  },
                  "overflow": {
                    "value": "auto",
                    "hide": true
                  }
                },
                "globalId": "5ab9ba6e-f164-4c25-b0d4-54fd5f412ce2",
                "parentId": [
                  8,
                  4,
                  1
                ],
                "parentGlobalId": [
                  "3605ddf4-b396-437c-b602-4674bee8b578",
                  "66c0b87d-da55-4e55-9fd0-3390c1960dfc",
                  "a4a285f5-8651-4a5a-8243-4428ff27cd27"
                ],
                "headerId": 10
              },
              {
                "id": 15,
                "order": 2,
                "type": "TextBox",
                "properties": {
                  "name": {
                    "value": "Step",
                    "control": "TextBox"
                  },
                  "field": {
                    "value": "TextBox",
                    "control": "TextBox"
                  },
                  "text": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "actions": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "readOnly": {
                    "value": true,
                    "control": "CheckBox"
                  },
                  "placeholder": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "toolTip": {
                    "value": true,
                    "control": "CheckBox"
                  },
                  "toolTipText": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "maxLength": {
                    "value": 200,
                    "control": "TextBox"
                  },
                  "type": {
                    "value": "String",
                    "control": "ListBox",
                    "values": [
                      {
                        "id": "0",
                        "item": "String",
                        "value": "String"
                      },
                      {
                        "id": "1",
                        "item": "Integer",
                        "value": "Integer"
                      },
                      {
                        "id": "2",
                        "item": "Decimal",
                        "value": "Decimal"
                      }
                    ]
                  },
                  "masks": {
                    "value": "",
                    "control": "TextBox",
                    "maskValue": ""
                  },
                  "validations": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "REQUIRE",
                        "value": {
                          "id": "1",
                          "type": "REQUIRE",
                          "events": [
                            "onBlur",
                            "onSubmit"
                          ]
                        }
                      },
                      {
                        "id": "2",
                        "item": "NUMBER",
                        "value": {
                          "id": "2",
                          "type": "NUMBER",
                          "events": [
                            "onChange",
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "3",
                        "item": "EMAIL",
                        "value": {
                          "id": "3",
                          "type": "EMAIL",
                          "events": [
                            "onBlur"
                          ]
                        }
                      },
                      {
                        "id": "4",
                        "item": "UNIQUE",
                        "value": {
                          "id": "4",
                          "type": "UNIQUE",
                          "events": [
                            "onBlur"
                          ]
                        }
                      },
                      {
                        "id": "5",
                        "item": "NOSPACE",
                        "value": {
                          "id": "5",
                          "type": "NOSPACE",
                          "events": [
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "6",
                        "item": "NOSPECIALCHAR",
                        "value": {
                          "id": "6",
                          "type": "NOSPECIALCHAR",
                          "events": [
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "7",
                        "item": "PATTERN",
                        "value": {
                          "id": "7",
                          "type": "PATTERN",
                          "events": [
                            "onBlur"
                          ]
                        }
                      }
                    ]
                  },
                  "operators": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "equal",
                        "value": {
                          "id": "1",
                          "type": "equal"
                        }
                      },
                      {
                        "id": "2",
                        "item": "not equal",
                        "value": {
                          "id": "2",
                          "type": "not equal"
                        }
                      },
                      {
                        "id": "3",
                        "item": "greater",
                        "value": {
                          "id": "3",
                          "type": "greater"
                        }
                      },
                      {
                        "id": "4",
                        "item": "greater & equal",
                        "value": {
                          "id": "4",
                          "type": "greater & equal"
                        }
                      },
                      {
                        "id": "5",
                        "item": "lower",
                        "value": {
                          "id": "5",
                          "type": "lower"
                        }
                      },
                      {
                        "id": "6",
                        "item": "lower & equal",
                        "value": {
                          "id": "6",
                          "type": "lower & equal"
                        }
                      },
                      {
                        "id": "7",
                        "item": "contains",
                        "value": {
                          "id": "7",
                          "type": "contains"
                        }
                      },
                      {
                        "id": "8",
                        "item": "starts with",
                        "value": {
                          "id": "8",
                          "type": "starts with"
                        }
                      },
                      {
                        "id": "9",
                        "item": "ends with",
                        "value": {
                          "id": "9",
                          "type": "ends with"
                        }
                      }
                    ]
                  },
                  "prefix": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "suffix": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "wholeNumberLength": {
                    "value": 10,
                    "control": "TextBox"
                  },
                  "decimalSize": {
                    "value": 2,
                    "control": "TextBox"
                  },
                  "decimalSeparator": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "groupSize": {
                    "value": 3,
                    "control": "TextBox"
                  },
                  "groupSeparator": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "index": {
                    "value": false,
                    "control": "CheckBox"
                  }
                },
                "policy": {
                  "read": true,
                  "edit": true,
                  "delete": true
                },
                "styles": {
                  "fontSize": {
                    "value": "14px"
                  },
                  "fontFamily": {
                    "value": "Arial"
                  },
                  "color": {
                    "value": "#212121"
                  },
                  "left": {
                    "value": 10,
                    "hide": true
                  },
                  "top": {
                    "value": 50,
                    "hide": true
                  },
                  "width": {
                    "value": "209px",
                    "hide": true
                  },
                  "display": {
                    "value": "flex",
                    "hide": true
                  },
                  "height": {
                    "value": "25px",
                    "hide": true
                  },
                  "visibility": {
                    "value": "visible"
                  },
                  "borderLeft": {
                    "value": "1px solid #cccccc"
                  },
                  "borderTop": {
                    "value": "1px solid #cccccc"
                  },
                  "borderTopLeftRadius": {
                    "value": "2px"
                  },
                  "borderTopRightRadius": {
                    "value": "2px"
                  },
                  "borderRight": {
                    "value": "1px solid #cccccc"
                  },
                  "borderBottom": {
                    "value": "1px solid #cccccc"
                  },
                  "borderBottomLeftRadius": {
                    "value": "2px"
                  },
                  "borderBottomRightRadius": {
                    "value": "2px"
                  },
                  "background": {
                    "value": "white"
                  },
                  "boxSizing": {
                    "value": "border-box",
                    "hide": true
                  },
                  "textAlign": {
                    "value": "left"
                  },
                  "resize": {
                    "value": "both",
                    "hide": true
                  },
                  "overflow": {
                    "value": "auto",
                    "hide": true
                  }
                },
                "globalId": "2d92ae8d-ce8e-46d7-b2ba-8de0dd0ed82b",
                "parentId": [
                  8,
                  4,
                  1
                ],
                "parentGlobalId": [
                  "3605ddf4-b396-437c-b602-4674bee8b578",
                  "66c0b87d-da55-4e55-9fd0-3390c1960dfc",
                  "a4a285f5-8651-4a5a-8243-4428ff27cd27"
                ],
                "headerId": 14
              },
              {
                "id": 23,
                "order": 2,
                "type": "TextBox",
                "properties": {
                  "name": {
                    "value": "Decision",
                    "control": "TextBox"
                  },
                  "field": {
                    "value": "TextBox",
                    "control": "TextBox"
                  },
                  "text": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "actions": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "readOnly": {
                    "value": false,
                    "control": "CheckBox"
                  },
                  "placeholder": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "toolTip": {
                    "value": true,
                    "control": "CheckBox"
                  },
                  "toolTipText": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "maxLength": {
                    "value": 200,
                    "control": "TextBox"
                  },
                  "type": {
                    "value": "String",
                    "control": "ListBox",
                    "values": [
                      {
                        "id": "0",
                        "item": "String",
                        "value": "String"
                      },
                      {
                        "id": "1",
                        "item": "Integer",
                        "value": "Integer"
                      },
                      {
                        "id": "2",
                        "item": "Decimal",
                        "value": "Decimal"
                      }
                    ]
                  },
                  "masks": {
                    "value": "",
                    "control": "TextBox",
                    "maskValue": ""
                  },
                  "validations": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "REQUIRE",
                        "value": {
                          "id": "1",
                          "type": "REQUIRE",
                          "events": [
                            "onBlur",
                            "onSubmit"
                          ]
                        }
                      },
                      {
                        "id": "2",
                        "item": "NUMBER",
                        "value": {
                          "id": "2",
                          "type": "NUMBER",
                          "events": [
                            "onChange",
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "3",
                        "item": "EMAIL",
                        "value": {
                          "id": "3",
                          "type": "EMAIL",
                          "events": [
                            "onBlur"
                          ]
                        }
                      },
                      {
                        "id": "4",
                        "item": "UNIQUE",
                        "value": {
                          "id": "4",
                          "type": "UNIQUE",
                          "events": [
                            "onBlur"
                          ]
                        }
                      },
                      {
                        "id": "5",
                        "item": "NOSPACE",
                        "value": {
                          "id": "5",
                          "type": "NOSPACE",
                          "events": [
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "6",
                        "item": "NOSPECIALCHAR",
                        "value": {
                          "id": "6",
                          "type": "NOSPECIALCHAR",
                          "events": [
                            "onkeyPress"
                          ]
                        }
                      },
                      {
                        "id": "7",
                        "item": "PATTERN",
                        "value": {
                          "id": "7",
                          "type": "PATTERN",
                          "events": [
                            "onBlur"
                          ]
                        }
                      }
                    ]
                  },
                  "operators": {
                    "value": "",
                    "control": "ListBoxCheckBox",
                    "selectedValues": [],
                    "values": [
                      {
                        "id": "1",
                        "item": "equal",
                        "value": {
                          "id": "1",
                          "type": "equal"
                        }
                      },
                      {
                        "id": "2",
                        "item": "not equal",
                        "value": {
                          "id": "2",
                          "type": "not equal"
                        }
                      },
                      {
                        "id": "3",
                        "item": "greater",
                        "value": {
                          "id": "3",
                          "type": "greater"
                        }
                      },
                      {
                        "id": "4",
                        "item": "greater & equal",
                        "value": {
                          "id": "4",
                          "type": "greater & equal"
                        }
                      },
                      {
                        "id": "5",
                        "item": "lower",
                        "value": {
                          "id": "5",
                          "type": "lower"
                        }
                      },
                      {
                        "id": "6",
                        "item": "lower & equal",
                        "value": {
                          "id": "6",
                          "type": "lower & equal"
                        }
                      },
                      {
                        "id": "7",
                        "item": "contains",
                        "value": {
                          "id": "7",
                          "type": "contains"
                        }
                      },
                      {
                        "id": "8",
                        "item": "starts with",
                        "value": {
                          "id": "8",
                          "type": "starts with"
                        }
                      },
                      {
                        "id": "9",
                        "item": "ends with",
                        "value": {
                          "id": "9",
                          "type": "ends with"
                        }
                      }
                    ]
                  },
                  "prefix": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "suffix": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "wholeNumberLength": {
                    "value": 10,
                    "control": "TextBox"
                  },
                  "decimalSize": {
                    "value": 2,
                    "control": "TextBox"
                  },
                  "decimalSeparator": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "groupSize": {
                    "value": 3,
                    "control": "TextBox"
                  },
                  "groupSeparator": {
                    "value": "",
                    "control": "TextBox"
                  },
                  "index": {
                    "value": false,
                    "control": "CheckBox"
                  }
                },
                "policy": {
                  "read": true,
                  "edit": true,
                  "delete": true
                },
                "styles": {
                  "fontSize": {
                    "value": "14px"
                  },
                  "fontFamily": {
                    "value": "Arial"
                  },
                  "color": {
                    "value": "#212121"
                  },
                  "left": {
                    "value": 708,
                    "hide": true
                  },
                  "top": {
                    "value": 38,
                    "hide": true
                  },
                  "width": {
                    "value": "176px",
                    "hide": true
                  },
                  "display": {
                    "value": "flex",
                    "hide": true
                  },
                  "height": {
                    "value": "25px",
                    "hide": true
                  },
                  "visibility": {
                    "value": "visible"
                  },
                  "borderLeft": {
                    "value": "1px solid #cccccc"
                  },
                  "borderTop": {
                    "value": "1px solid #cccccc"
                  },
                  "borderTopLeftRadius": {
                    "value": "2px"
                  },
                  "borderTopRightRadius": {
                    "value": "2px"
                  },
                  "borderRight": {
                    "value": "1px solid #cccccc"
                  },
                  "borderBottom": {
                    "value": "1px solid #cccccc"
                  },
                  "borderBottomLeftRadius": {
                    "value": "2px"
                  },
                  "borderBottomRightRadius": {
                    "value": "2px"
                  },
                  "background": {
                    "value": "white"
                  },
                  "boxSizing": {
                    "value": "border-box",
                    "hide": true
                  },
                  "textAlign": {
                    "value": "left"
                  },
                  "resize": {
                    "value": "both"
                  },
                  "overflow": {
                    "value": "auto",
                    "hide": true
                  }
                },
                "globalId": "da8c426a-6c8a-4f92-af82-8802190aa275",
                "parentId": [
                  8,
                  4,
                  1
                ],
                "parentGlobalId": [
                  "3605ddf4-b396-437c-b602-4674bee8b578",
                  "66c0b87d-da55-4e55-9fd0-3390c1960dfc",
                  "a4a285f5-8651-4a5a-8243-4428ff27cd27"
                ],
                "left": {
                  "value": 708
                },
                "top": {
                  "value": 38
                },
                "clickRelativePosition": {
                  "left": 45,
                  "top": 17
                },
                "headerId": 22
              }
            ],
            "policy": {
              "read": true,
              "edit": true,
              "delete": true
            },
            "styles": {
              "fontSize": {
                "value": "14px"
              },
              "fontFamily": {
                "value": "Arial"
              },
              "color": {
                "value": "#cccccc"
              },
              "backgroundColor": {
                "value": "white"
              },
              "height": {
                "value": "30px",
                "hide": true
              },
              "width": {
                "value": "100%",
                "hide": true
              },
              "display": {
                "value": "flex",
                "hide": true
              },
              "position": {
                "value": "relative",
                "hide": true
              },
              "boxSizing": {
                "value": "border-box",
                "hide": true
              },
              "overflow": {
                "value": "hidden",
                "hide": true
              },
              "border": {
                "value": "1px solid #cccccc"
              }
            },
            "left": {
              "value": 1
            },
            "top": {
              "value": 1
            },
            "globalId": "3605ddf4-b396-437c-b602-4674bee8b578",
            "parentId": [
              4,
              1
            ],
            "parentGlobalId": [
              "66c0b87d-da55-4e55-9fd0-3390c1960dfc",
              "a4a285f5-8651-4a5a-8243-4428ff27cd27"
            ]
          }
        ],
        "policy": {
          "read": true,
          "edit": true,
          "delete": true
        },
        "styles": {
          "fontSize": {
            "value": "14px"
          },
          "fontFamily": {
            "value": "Arial"
          },
          "color": {
            "value": "#cccccc"
          },
          "width": {
            "value": "573px",
            "hide": true
          },
          "height": {
            "value": "576px",
            "hide": true
          },
          "resize": {
            "value": "both",
            "hide": true
          },
          "position": {
            "value": "absolute",
            "hide": true
          },
          "boxSizing": {
            "value": "border-box",
            "hide": true
          },
          "zIndex": {
            "value": 1,
            "hide": true
          },
          "backgroundColor": {
            "value": "white"
          },
          "border": {
            "value": "1px solid #cccccc"
          },
          "overflow": {
            "value": "auto",
            "hide": true
          },
          "left": {
            "value": 1,
            "hide": true
          },
          "top": {
            "value": 1,
            "hide": true
          }
        },
        "excludesDropTypes": [
          "Label",
          "DataGrid",
          "Line",
          "Radio",
          "GroupBox",
          "Button",
          "RichTextBox",
          "TreeBox",
          "TextEditor"
        ],
        "parentId": [
          1
        ],
        "left": {
          "value": 1
        },
        "top": {
          "value": 1
        },
        "globalId": "66c0b87d-da55-4e55-9fd0-3390c1960dfc",
        "parentGlobalId": [
          "a4a285f5-8651-4a5a-8243-4428ff27cd27"
        ]
      }
    ],
    "globalId": "a4a285f5-8651-4a5a-8243-4428ff27cd27",
    "styles": {
      "border": {
        "value": "none"
      },
      "backgroundColor": {
        "value": "white"
      },
      "margin": {
        "value": "0 auto",
        "hide": true
      },
      "color": {
        "value": "#212121"
      },
      "width": {
        "value": "581px",
        "hide": true
      },
      "resize": {
        "value": "auto",
        "hide": true
      },
      "position": {
        "value": "relative",
        "hide": true
      },
      "height": {
        "value": "586px",
        "hide": true
      }
    },
    "id": 1,
    "type": "Form",
    "parentGlobalId": [],
    "parentId": [],
    "properties": {
      "name": {
        "value": "Form",
        "control": "TextBox"
      },
      "text": {
        "value": "Form",
        "control": "TextBox"
      },
      "actualize": {
        "control": "TextBox",
        "hide": true,
        "value": 0
      },
      "actions": {
        "value": "",
        "control": "TextBox"
      }
    },
    "order": 1,
    "policy": {
      "read": true,
      "edit": true,
      "delete": true
    }
  }],

  apiSchemas:[],
 currentMetaData:{id:0, maxId:0,  isSealed:false}


}
  const  [user, setUser] = useState({ 
    id: uuid.v4(),
    firstName : "",
    lastName : "",
    email : "",
    password : Math.floor(1000 + Math.random() * 9000),
    resetPassword : true,
    errors:[],
    loading:false,
    canEdit:false,
    organigramId : new URLSearchParams(useLocation().search).get("organigramId"),
    profilGlobalId : new URLSearchParams(useLocation().search).get("profilGlobalId"),
    isEqual:false,
    isUpdate:false,
 })

 
  const refreshData =(result, currentFormData = undefined) => {
   var updatedFormData = currentFormData ? currentFormData : JSON.parse(JSON.stringify(globalState.state.formData));
   if (!updatedFormData.apiData) 
      updatedFormData.apiData = []
   else
      updatedFormData.apiData = updatedFormData.apiData.filter(item => item.globalId != formData.apiSchemas[0].globalId)
   updatedFormData.apiData.push({globalId:formData.apiSchemas[0].globalId, id:formData.apiSchemas[0].id,  data:result})
   dispatch({
     type: "UPDATE_FORM_WITOUT_HISTORIQUE",
     payload: updatedFormData
   });  };
  
  const onSelectProfil = (itemSelected) => {
   
    var userData = JSON.parse(JSON.stringify(user));
    setUser({...userData, loading:true })
    axiosOperation({method:"GET"
      , url: "https://flex-services.onrender.com/profilUser/?id="+ itemSelected.id
      , body: {confirmed:true, nTry:0}
      }).then(response => 
        { 
          
         if(response.managedError) {
            
            const result = response.result.data
            if (result[0]) {
              
               //refreshData(result)
               var updatedFormData = JSON.parse(JSON.stringify(globalState.state.formData));
               const emptyValue = ""
               setCurrentRowData(updatedFormData, emptyValue)
         
               setUser({...user, profilGlobalId:itemSelected.id, showDelete:false, loading:false, canEdit:false
                  ,firstName:emptyValue,lastName:emptyValue, email:emptyValue, isUpdate:false,isEqual:true})
         
               refreshData(result, updatedFormData)
              
            } else setUser({...user, loading:false, profilGlobalId:itemSelected.id})
         } else setUser({...user, loading:false, profilGlobalId:itemSelected.id})
       
          
        })
    
  }

  const setCurrentRowData = (updatedFormData, value=undefined) => {
  
   var newValue = {}
  
   var currentsTools = [];
   getCurrentsTools(updatedFormData, currentsTools, [firstNameId, lastNameId, emailId]);
   currentsTools.filter(item => {
      switch (item.id) {
         case firstNameId:
            item.properties.text.value = value != undefined ? value : getCurrentRowComponentValue(headerFirstNameId)
            newValue["firstName"] = item.properties.text.value
            break;
         case lastNameId:
            item.properties.text.value = value != undefined  ? value :getCurrentRowComponentValue(headerLastNameId)
            newValue["lastName"] = item.properties.text.value
            break;
         case emailId:
            
            item.properties.text.value = value != undefined  ? value :getCurrentRowComponentValue(headerEmailId)
            newValue["email"] = item.properties.text.value
            break;
      }   
      
   });
   
   updatedFormData.errors = []
   
   return newValue
  };

 const getCurrentRowComponentValue = (id) => {
  
   return globalState.state.formData.currentRow[0].metaData.filter(item => item.headerId == id)[0].properties.text.value
 }
  

  useEffect(() => {
   
    dispatch({
      type: "SET_META_DATA",
      payload: formData
    });
      
  }, []);
  
  
 return (

    <React.Fragment>
      <div style = {{ marginLeft:"auto",  marginRight:"auto",width:"575px"
    , borderRadius: "4px"
    , padding: "0 20px 20px 20px"
    , marginTop:"5px" , backgroundColor: "white" }}>
      {/*settings.showDiscard && <SimpleDialog changeModeRequired ={false} 
              onClickValid ={(e) => onDiscard(e)} onClose = {() => setSetting({...settings, showDiscard:false})}  
              value = "Are you sure ?"
              isLabel = {true}
        parentId = "InformationDiscardCommand" type = "field" operation = "DISCARD"/>*/}
      <FormSettings isExecutionMode = {true}/>
    
    {/*<div style = {{ marginLeft:"auto",  marginRight:"auto",width:"760px"  }}>
      
    </div>*/}
    </div>
    </React.Fragment>
  );
};

/*

      <div style = {{ display:"flex" ,marginTop:"10px" ,marginBottom:"10px"  }}>
        
        {isNewRegister && <input id="FistName" type="textBox" placeholder="First Name" value={user.fistName}  
          onChange={(e)=> setUser({...user, fistName:e.target.value})}
          onBlur={(e) => fireOtherEvent(e, {id:"FistName", name:"First Name" }, [{type :"REQUIRE"}])}
          onKeyPress={(e) => fireEventKeyPress(e, {id:"FistName" })}
          style = {{ marginRight:"10px", fontSize:"14px"   }}
          className="input connexionInput" />}
        {isNewRegister && getError("FistName")}
        
        
        {isNewRegister && <input id="LastName" type="textBox" placeholder="Last Name" value={user.lastName} 
          onChange={(e)=> setUser({...user, lastName:e.target.value})}
          onBlur={(e) => fireOtherEvent(e, {id:"LastName", name:"Last Name" }, [{type :"REQUIRE"}])}
          onKeyPress={(e) => fireEventKeyPress(e, {id:"LastName" }, [{type :"REQUIRE"}])}
          style = {{ marginRight:"10px" , fontSize:"14px"  }}
          className="input connexionInput" />}
        { isNewRegister && getError("LastName")}
        
        
        {<input id="Email" type="textBox" placeholder="Email" value={user.email} 
          readOnly={user.log && user.log.activeResendEmail} 
          onChange={(e)=> setUser({...user, email:e.target.value})}
          onBlur={(e) => fireOtherEvent(e, {id:"Email", name:"Email" }, [{type :"REQUIRE"}, {type :"EMAIL"}])}
          onKeyPress={(e) => fireEventKeyPress(e, {id:"Email" })}
          style = {{ fontSize:"14px"   }}
          className="input connexionInput" />}
        {isNewRegister && getError("Email")}      
        
      </div>
      
<div style = {{ textAlign:"center", display:"flex" }}>
        <Link  style = {{ fontFamily:"Verdana", marginRight:"auto", textDecoration: "none"  }}to="/register">
          <span style = {{ fontSize:"12px", color:"#008dff"}} >Forget password?</span>
        </Link>
        <Link style = {{ fontFamily:"Verdana", marginLeft:"auto", textDecoration: "none"  }} to="/register">
          <span style = {{ fontSize:"12px", color:"yellowGreen" }} >Sign In</span>
        </Link>
      </div>
  */


